import { Suspense, lazy } from 'react';

import { KDErrorBoundary } from '@/components';
import { KDLayoutDashboardLoader } from '@/layouts';

const StoresFormPage = lazy(() => import('./StoresForm.page'));

export const StoresForm = () => {
  return (
    <KDErrorBoundary>
      <Suspense fallback={<KDLayoutDashboardLoader />}>
        <StoresFormPage />
      </Suspense>
    </KDErrorBoundary>
  );
};
